import { useEffect } from 'react';
import api from 'utils/api';
import qs from 'qs';
import { KEY_MEMBERCERTIFICATIONSEQ, KEY_EXPIRETIME } from 'tools/WebTool';
import { useApp } from '../../../contexts/AppContext';

const IdentificationSuccessCallback = () => {
  const {
    auth: { authenticated },
  } = useApp();

  const search = window.location.search;

  useEffect(() => {
    const query = qs.parse(search, {
      ignoreQueryPrefix: true,
      decoder: s => s,
    });

    const encodeData = query.EncodeData;
    const uniqueKey = query.key;

    const callbacks =
      window.opener?.__identificationGlobalCallbacks?.[uniqueKey];

    if (!callbacks) {
      alert('유효하지 않은 인증 요청입니다.');
      window.close();
      return;
    }

    const purposeType = callbacks.purposeType || 'NONE';

    decodeData({
      encodeData,
      purposeType,
      authenticated,
      onSuccess: callbacks.success,
      onFail: callbacks.fail,
      onExcept: callbacks.except,
    });
  }, [search, authenticated]);

  return null;
};

const decodeData = ({
  encodeData,
  purposeType,
  authenticated,
  onSuccess,
  onFail,
  onExcept,
}) => {
  const apiUrl = authenticated
    ? '/v1/au/nice-id/decode'
    : '/v1/na/nice-id/decode';

  api({
    url: apiUrl,
    method: 'post',
    headers: { 'content-type': 'application/json' },
    data: {
      encodeData: encodeData || '',
      isSuccess: true,
      purposeType,
    },
  })
    .then(res => {
      const today = new Date();
      const expireTime = new Date(
        today.getFullYear(),
        today.getMonth(),
        today.getDate(),
        23,
        59,
        59
      );

      const data = res.data;
      if (!data.success) {
        alert(data?.message || '');
        onFail?.();
      } else if (data?.data?.code !== '0000') {
        alert(data?.data?.message || '인증 실패');
        onFail?.();
      } else if (!data?.data?.memberCertificationSeq) {
        alert('잘못된 인증 정보입니다.\n관리자에게 문의하세요.');
        onFail?.();
      } else {
        localStorage.setItem(
          KEY_MEMBERCERTIFICATIONSEQ,
          data.data.memberCertificationSeq
        );
        localStorage.setItem(KEY_EXPIRETIME, expireTime);
        onSuccess?.(data.data.memberCertificationSeq);
      }

      window.close();
    })
    .catch(err => {
      console.error(err);
      onExcept?.(err);
      window.close();
    });
};

export default IdentificationSuccessCallback;
